import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><img parentName="p" {...{
        "src": "http://www.reeves.nl/upload/telescoping2024-text.gif",
        "alt": "Telescoping Transforms"
      }}></img></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
    </ul>
    <p>{`Where mid-ocean ridges are offset by transforms, the extinct (aseismic) sections of the transform are left behind, growing steadily in length as each of the conjugate continents retreats from the mid-ocean ridge. If we wish to reconstruct the paleo-positions of the continents we must honour this process and retrace extinct fracture zones by telescoping them into each other, reversing the process of their creation (Reeves & de Wit, 2000). To do this in practice on a map, lengths of the fracture zone have to be attached to the appropriate continental fragment and be 'time-windowed' so that they disaapear progressively when maps are drawn of earlier times when the younger sections did not yet exist. The reconstruction model then has to be built so that the fracture zones remain coincident and colinear. This proves to be a major constraint on paelopositions (arguably more important than the coincidence of marine magnetic anomalies) and the only positional constraint available during the Cretaceous Quiet Zone (121.4 to 83.64 Ma). This process is illustrated in the 'reverse' animation. The work is made easier by using Euler interval poles since the Euler latitude lines (or small circles) about these poles are always parallel to the lengths of fracture zones created in the time interval to which they apply. It turns out that a small number of key transforms, often with large offsets (>1000 km), emerge. Their precise traces, interpreted from images of ocean-floor topography, confine the working model within tight limits. Often the origin of these defining structures may be traced back to pre-existing faults within re-assembled Gondwana. The available marine magnetic anomalies must, of course, be used to calibrate this process against time. The 'forward' part of the animation shows the result of adjusting the rotation parameters of all the fragments of Gondwana as carefully as possible to ensure the integrity of these major features. `}</p>
    <p>{`Reeves, C.V., & de Wit, M.J., 2000.  Making ends meet in Gondwana.  Terra Nova 12, No.6, p 272-282.`}</p>
    <p><em parentName="p">{`Last update 2024 June 6`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../gondwana"
        }}>{`Return to Gondwana main page`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      